@if (projectNgModel) {
<div class="overview">
  <div class="description">{{ projectNgModel.description }}</div>
  <div class="wrapper">
    <app-property-block icon="business_center" title="Business unit" [content]="projectNgModel.businessUnit"> </app-property-block>
    <app-separator></app-separator>
    <app-property-block icon="public" title="Region" [content]="projectNgModel.region"> </app-property-block>
    <app-property-block class="no-image-prop" title="Country" [content]="projectNgModel.country"> </app-property-block>
    <app-separator></app-separator>
    <app-property-block icon="pin_drop" title="Location" [content]="projectNgModel.location"> </app-property-block>
    <app-separator></app-separator>
    <app-property-block icon="today" title="Created at" content="{{ projectNgModel.createdAt | date : 'MMMM dd, yyyy' }}">
    </app-property-block>
    <app-separator></app-separator>
    <app-property-block icon="lock" title="Created by" [content]="projectNgModel.createdByName"> </app-property-block>
  </div>
</div>
}
